import React, { useState } from "react"
import { Clock, Sparkles } from "lucide-react"
import { DASHBOARD_ACTIVITY_PREVIEW_LIMIT } from "../../../../api/studentDashboard"
import type { DashboardActivity } from "../types"
import { sliceForShowMore } from "../utils/sliceForShowMore"
import DashboardActivityItem from "./DashboardActivityItem"
import DashboardShowMoreButton from "./DashboardShowMoreButton"
import "./DashboardActivityPanel.style.scss"

interface DashboardActivityPanelProps {
  activities: DashboardActivity[]
  loading?: boolean
  error?: string | null
}

const DashboardActivityPanel = ({
  activities,
  loading = false,
  error = null,
}: DashboardActivityPanelProps) => {
  const [showAll, setShowAll] = useState(false)
  const visibleActivities = sliceForShowMore(
    activities,
    showAll,
    DASHBOARD_ACTIVITY_PREVIEW_LIMIT
  )

  return (
    <section className="dashboard-activity-panel">
      <div className="dashboard-activity-panel__head">
        <h3>
          <Clock size={20} />
          Recent Activity
        </h3>
      </div>

      {loading ? (
        <div className="dashboard-activity-panel__empty">
          <p>Loading activity…</p>
        </div>
      ) : error ? (
        <div className="dashboard-activity-panel__empty">
          <p>{error}</p>
        </div>
      ) : activities.length === 0 ? (
        <div className="dashboard-activity-panel__empty">
          <Sparkles size={32} aria-hidden />
          <p>No activity yet</p>
          <span>
            Attempt a question or generate a paper to get started.
          </span>
        </div>
      ) : (
        <>
          <div className="dashboard-activity-panel__list">
            {visibleActivities.map((activity) => (
              <DashboardActivityItem key={activity.id} activity={activity} />
            ))}
          </div>
          <DashboardShowMoreButton
            expanded={showAll}
            extraCount={activities.length - DASHBOARD_ACTIVITY_PREVIEW_LIMIT}
            onToggle={() => setShowAll((open) => !open)}
          />
        </>
      )}
    </section>
  )
}

export default DashboardActivityPanel
